import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/not-found-screen';
import { useNavigate } from 'react-router';

function NotFound() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(LINKS.HOME);
  };

  return <Screen handleClick={handleClick} />;
}
export default NotFound;
